import React from "react";
import ReactDom from "react-dom";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";
import axios from "axios";

import mapPinIcon from "../images/icons/ui/icon-map-pin.svg";

const defaultCenter = {
  lat: 51.502,
  lng: -0.138,
};
const defaultZoom = 14;

const SimpleBlockMap = withScriptjs(
  withGoogleMap((props) => {
    const { markers, center, zoom } = props;
    const defaultOptions = {
      disableDefaultUI: true,
      styles: [
        {
          featureType: "administrative",
          elementType: "labels.text.fill",
          stylers: [{ color: "#736745" }],
        },
        {
          featureType: "landscape",
          elementType: "geometry",
          stylers: [{ color: "#f4f4f4" }],
        },
        {
          featureType: "poi",
          stylers: [{ visibility: "off" }],
        },
        {
          featureType: "road",
          elementType: "labels",
          stylers: [{ color: "#bababa" }],
        },
        {
          featureType: "road",
          elementType: "labels.text.stroke",
          stylers: [{ color: "#ffffff" }],
        },
        {
          featureType: "road",
          elementType: "labels.text.fill",
          stylers: [{ color: "#969696" }],
        },
        {
          featureType: "road",
          elementType: "geometry",
          stylers: [{ color: "#ffffff" }],
        },
        {
          featureType: "road",
          elementType: "geometry.stroke",
          stylers: [{ color: "#969696" }],
        },
        {
          featureType: "road.highway",
          elementType: "geometry",
          stylers: [{ color: "#e1e1e1" }],
        },
        {
          featureType: "transit",
          stylers: [{ visibility: "off" }],
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [{ color: "#bababa" }],
        },
        {
          featureType: "water",
          elementType: "labels",
          stylers: [{ visibility: "off" }],
        },
      ],
    };
    return (
      <GoogleMap
        defaultZoom={defaultZoom}
        defaultCenter={defaultCenter}
        defaultOptions={defaultOptions}
        center={center}
        zoom={zoom}
      >
        {markers.map(({ lat, lng }, index) => {
          return (
            <Marker key={index} position={{ lat, lng }} icon={mapPinIcon} clickable={false} />
          );
        })}
      </GoogleMap>
    );
  })
);

const MapBlock = () => {
  const [markers, setMarkers] = React.useState([])
  const [center, setCenter] = React.useState(defaultCenter)
  const [zoom, setZoom] = React.useState(defaultZoom)
  const venuesUrl = `${API_BASE_URL}/venues/search`;
  const getUserLocation = () =>
    new Promise((resolve, reject) => {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve({
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            });
          },
          (error) => {
            reject(error);
          }
        );
      } else {
        reject("No navigator.geolocation available");
      }
    });

  const doRequest = async (coordsText) => {
    return await axios.post(venuesUrl, {
      type: "location",
      radius: 8,
      text: coordsText || `${defaultCenter.lat},${defaultCenter.lng}`,
    });
  };

  const requestVenues = async () => {
    let response;
    try {
      // User location
      const { lat, lng } = await getUserLocation();
      response = await doRequest(`${lat},${lng}`);
      if (response?.data?.results < 1) {
        throw Error("No venues near user location");
      }
      setCenter({ lat, lng })
    } catch (err) {
      // Default location
      response = await doRequest();
    }
    const results = response?.data?.results || null;
    if (results) {
      // Zoom out if no near venues
      const anyNear = results.some((venue) => venue.distance < 4);
      if (!anyNear) setZoom(12)

      const newMarkers = Object.values(results).map(({ latitude, longitude }) => ({
        lat: Number(latitude),
        lng: Number(longitude),
      }));
      setMarkers(newMarkers)
    }
  };

  React.useEffect(() => {
    requestVenues();
  }, []);

  const googleMapKey = "AIzaSyDfEbj2R0tluLwQuq_t-mTFzHGub8tblYk";
  const googleMapURL = `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${googleMapKey}`;

  return (
    <SimpleBlockMap
      googleMapURL={googleMapURL}
      loadingElement={<div className="c-map-block__loading" />}
      containerElement={<div className="c-map-block__container" />}
      mapElement={<div className="c-map-block__map" />}
      markers={markers}
      center={center}
      zoom={zoom}
    />
  );
};

const MapInit = () => {
  const el = document.getElementById("js-mapBlock");
  if (el) {
    ReactDom.render(<MapBlock />, el);
  }
};

MapInit();
